import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const customIssueRoute: InvariantJiraRoute = {
	name: 'servicedesk-queues-custom-issue-detail',
	path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey',
	exact: true,
};
